import { FormattedMessage, useIntl } from 'react-intl';

import type { JobFilterSalary } from '@xing-com/crate-common-graphql-types';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  MAX_SALARY,
  MIN_SALARY,
  SEARCH_STATE_DISABLED_FILTER_PARAMS,
  SEARCH_STATE_PARAMS,
} from '@xing-com/crate-jobs-constants';

import { SalaryValue } from '../../salary-value';
import { Tag } from '../applied-filters.styles';

type Props = {
  option: JobFilterSalary & { isExtracted?: boolean };
};

export const SalaryTag: React.FC<Props> = ({ option }) => {
  const { formatMessage } = useIntl();
  const { setSearchParameter, deleteSearchParameter } = useSearchParameter();

  const handleOnClickSalary = (): void => {
    // Extracted filter
    if (option.isExtracted) {
      const disabledParamName = SEARCH_STATE_DISABLED_FILTER_PARAMS.salary;
      setSearchParameter(disabledParamName, 'true', { replace: false });

      return;
    }

    // Normal filter
    deleteSearchParameter(SEARCH_STATE_PARAMS.salary, { replace: false });
  };

  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: formatMessage({
        id: 'JOBS_SEARCH_FILTER_SALARY',
      }),
    }
  );

  return (
    <Tag onClick={handleOnClickSalary} aria-label={ariaLabel}>
      <FormattedMessage id="JOBS_SEARCH_FILTER_SALARY" />{' '}
      <SalaryValue
        min={option.min ?? MIN_SALARY}
        max={option.max ?? MAX_SALARY}
      />
    </Tag>
  );
};
